import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { get } from 'lodash'
import Waypoint from 'react-waypoint'

import Content, { HTMLContent } from '../components/Content'
import Header from '../components/Header'
import Nav from '../components/Nav'
import pic01 from '../assets/images/pic01.jpg'
import Product from '../templates/product-page'
import Footer from '../templates/footer-page'

const BigImageContainer = styled.div`
  position: relative;
  marging: 0;
`
const BigImage = styled.img`
  width: 100%;
  height: 20rem;
`
const BigImageTitle = styled.p`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 1rem;
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  background-color: rgba(255, 255, 255, 0.7);
`

const Products = styled.div`
  display: flex;
  flex-direction: column;
`

class Index extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      stickyNav: false,
    }
  }

  _handleWaypointEnter = () => {
    this.setState(() => ({ stickyNav: false }))
  }

  _handleWaypointLeave = () => {
    this.setState(() => ({ stickyNav: true }))
  }

  renderIntro = ({
    html,
    frontmatter: {
      headTitle,
      headDescription,
      button,
      bigImage,
      bigImageTitle,
    },
  }) => {
    return (
      <div>
        <BigImageContainer>
          <BigImage src={bigImage} alt="comparatif logiciel association" />
          <BigImageTitle>{bigImageTitle}</BigImageTitle>
        </BigImageContainer>
        <HTMLContent content={html} />
      </div>
    )
  }
  render() {
    const title = get(this, 'props.data.site.siteMetadata.title')
    const description = get(this, 'props.data.site.siteMetadata.description')
    const home = get(this, 'props.data.home.edges.0')
    const intro = get(home, 'node')
    const products = get(this, 'props.data.products.edges')
    console.log('​render -> props', this.props)
    console.log('​render -> home', home)
    console.log('​render -> products', products)
    const navItems = intro.frontmatter.menu || []
    const menuTitle = intro.frontmatter.menuTitle || ''
    const productsTitle = intro.frontmatter.productsTitle || ''
    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
        </Helmet>

        <Header {...get(home, 'node.frontmatter')} />

        <Waypoint
          onEnter={this._handleWaypointEnter}
          onLeave={this._handleWaypointLeave}
        />
        <Nav
          sticky={this.state.stickyNav}
          items={navItems}
          menuTitle={menuTitle}
        />

        <div id="main">
          <section id="intro" className="main">
            {this.renderIntro(intro)}
          </section>

          <Products>
            <section className="main special">
              <header className="major">
                <h2>{productsTitle}</h2>
              </header>
              {products &&
                products.map(({ node }) => (
                  <Product key={node.frontmatter.title} {...node} />
                ))}
            </section>
          </Products>
        </div>
        <Footer />
      </div>
    )
  }
}

Index.propTypes = {
  route: PropTypes.object,
}

export default Index

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    home: allMarkdownRemark(
      filter: { frontmatter: { path: { regex: "/home/" } } }
    ) {
      edges {
        node {
          html
          frontmatter {
            logo
            logoTitle
            title
            moto
            path
            menu
            menuTitle
            headDescription
            bigImage
            bigImageTitle
            productsTitle
          }
        }
      }
    }
    products: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { regex: "/product/" } } }
      sort: { fields: [frontmatter___index], order: ASC }
    ) {
      edges {
        node {
          html
          frontmatter {
            templateKey
            title
            index
          }
        }
      }
    }
    footer: allMarkdownRemark(
      filter: { frontmatter: { title: { regex: "/footer/" } } }
    ) {
      edges {
        node {
          html
          frontmatter {
            templateKey
            title
            index
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js